import Axios from "../../api/Axios";
const BASE_URL = "PriceVariation/";

export const EndpointPriceVariation = {
    GetAvailablePriceList: "GetAvailablePriceList",
    GetAllData: "GetAllData",
    GetExportData: "GetExportData"
};
export const createAPIEndpointPriceVariation = () => {
    return { get: (Endpoint) => Axios.get(BASE_URL + Endpoint) };
};
